<template>
  <div
    v-if="visible"
    :class="$b()"
  >
    <div
      :class="$b('overlay')"
    >
      <div :class="$b('outer')">
        <button
          :class="$b('close-button')"
          data-testid="cookie-consent-close-icon"
          @click="dismiss"
        >
          <VisionIcon
            icon="plus"
            colour="black"
            size="small"
          />
        </button>
        <div :class="$b('content')">
          <BaseHeading
            tag="h3"
            size="h2"
            :class="$b('title')"
          >
            {{ $tr('Privacy Settings') }}
          </BaseHeading>
          <BodyCopy :class="$b('text')">
            {{
              $tr(
                'To enhance site performance and your experience, this website uses cookies. Click continue to accept, or manage your '
              )
            }}
            <SecondaryLineLink
              size="regular"
              :class="$b('text-link')"
              is-button
              @click="modify"
            >
              {{ $tr('Cookie Preferences.') }}
            </SecondaryLineLink>
          </BodyCopy>
          <BodyCopy :class="$b('text')">
            {{ $tr('For more information, view our ') }}
            <SecondaryLineLink
              size="regular"
              :class="$b('text-link')"
              is-button
              @click.stop="openPrivacyPolicy"
            >
              {{ $tr('Privacy Policy.') }}
            </SecondaryLineLink>
          </BodyCopy>
          <div :class="$b('buttons')">
            <PrimaryButton
              :class="$b('button-accept')"
              @click="accept"
            >
              {{ $tr('Continue') }}
            </PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageCookieConsentBanner',
  props: {
    forceOff: {
      type: Boolean,
      default: false,
    },
  },
  setup () {
    const pageStore = usePageStore()
    const sidebarStore = useSidebarStore()

    const { showCookieModal, cookieStatus } = storeToRefs(pageStore)

    return {
      pageStore,
      sidebarStore,
      showCookieModal,
      cookieStatus
    }
  },
  data: () => ({
    visible: false,
  }),
  computed: {
    cookiesChecked () {
      return this.cookieStatus !== null
    }
  },
  mounted() {
    if (!this.showCookieModal && !this.cookiesChecked && !this.forceOff)
      this.visible = true
  },
  methods: {
    accept() {
      this.pageStore.setCookieStatus(true)
      this.visible = false
    },
    dismiss() {
      this.pageStore.setCookieStatus(false)
      this.visible = false
    },
    modify() {
      this.pageStore.toggleCookieModal(true)
    },
    openPrivacyPolicy() {
      this.openSidebarPage('privacy-policy')
    },
    openSidebarPage(slug) {
      this.sidebarStore.setActiveSidebar(slug)
    },
  },
}
</script>

<style lang="postcss">
.PageCookieConsentBanner {
  @apply fixed bg-off-black bg-opacity-80
    h-full w-full top-0 left-0
    opacity-100
    flex
    transition-all
    visible;
  z-index: 80;
  transition: 0s 0.5s;

  &--hidden {
    @apply hidden opacity-100;
    transition: 0s 0s;
  }
}

.PageCookieConsentBanner__overlay {
  @apply transition
    opacity-100
    flex-grow flex items-center justify-center;

  .PageCookieConsentBanner--hidden & {
    @apply opacity-0;
  }
}

.PageCookieConsentBanner__outer {
  @apply bg-white
    mt-auto my-0 sm:mr-sm sm:ml-auto mb-0 sm:mb-sm
    p-xs
    w-full sm:w-auto;

  @screen sm {
    border-radius: 10px;
    max-width: 544px;
  }

  .is-dark-chrome-theme & {
    @apply text-black;
  }
}

.PageCookieConsentBanner__close-button {
  @apply bg-white
    rounded-full
    flex items-center justify-center
    mt-xxs sm:mt-xs mr-xxs md:mr-xs ml-auto
    transition-all;
  font-size: 1.5em;
  transform: rotate(45deg);
}

.PageCookieConsentBanner__content {
  @apply pt-xs px-xs pb-xs md:px-md md:pb-md;
}

.PageCookieConsentBanner__title {
  @apply pb-sm md:pb-md;
}

.PageCookieConsentBanner__text {
  @apply mdMax:py-xs pb-sm;
}

.PageCookieConsentBanner__text-link {
  transform: translateY(-2px);
}

.PageCookieConsentBanner__buttons {
  @apply flex flex-col sm:flex-row items-center justify-between
    pt-xs md:pt-sm;
}

.PageCookieConsentBanner__button-accept {
  @apply w-full;

  @screen md {
    max-width: 192px;
  }
}

.PageCookieConsentBanner__button-modify {
  @apply text-center
    smMax:mt-xs
    w-full;

  @screen md {
    max-width: 192px;
  }
}
</style>
